<template>
  <div class="wrap" v-if="showModalBox">
    <!-- 模态框 -->
    <div class="modal-box-c">
      <h4>修改成功</h4>
      <span>请重新登陆！{{ num }}s后将自动返回首页页面</span>
      <div class="comfirm">
        <el-button type="primary" size="small" @click="comfirm"
          >重新登陆</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalBox",
  props: {
    showModalBox: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      num: 10,
      suo: null,
    };
  },
  created() {},
  mounted() {
    this.$watch("showModalBox", () => {
      if (this.showModalBox) {
        this.num = 10;
        this.suo = setInterval(() => {
          if (this.num == 0) {
            clearInterval(this.suo);
            this.clearInfo()
          } else {
            this.num--;
          }
        }, 1000);
      }
    });
    // this.showModalBox =
    //   this.$store.state.tokenInfo.updatePwd == "NO" ? false : true;
  },
  methods: {
    comfirm() {
      this.$emit("comfirm", false);
      this.clearInfo()
    },
    // 清楚缓存并返回首页
    clearInfo() {
      localStorage.clear();
      this.$router.push({
        name: 'login2'
      })
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  overflow: hidden;
  .modal-box-c {
    width: 442px;
    height: 136px;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 4px;
    box-sizing: border-box;
    > h4 {
      margin-bottom: 20px;
      color: #333333;
      font-size: 18px;
      font-weight: normal;
    }
    > span {
      display: inline-block;
      margin-bottom: 12px;
      color: #606266;
      font-size: 14px;
      letter-spacing: 2px;
    }
    .comfirm {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>